import Account from '@mdi/svg/svg/account.svg?react';
import { MDIIcon } from '@solinkcorp/solink-components';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import useLocale from 'src/hooks/useLocale';
import { SVG } from '../SVG';
import { type Event, type Info } from '../types/event.types';
import styles from './Header.module.sass';

interface HeaderProps {
  event: Event | null;
  info?: Info | null;
  sharePage?: boolean;
  alarmPage?: boolean;
  dataReady: boolean;
  error?: string;
}

// Component
const Header: React.FC<HeaderProps> = ({ event, info, sharePage, alarmPage, dataReady, error }) => {
  const locale = useLocale();
  if (error && error === locale.spa.requestedResourceIsUnavailable)
    return <div className={styles.header}></div>;
  /* Initialize title and user */
  let title;
  let user: string;

  /* If event is not falsy, define the title and user */
  if (event) {
    if (alarmPage) {
      [title] = event.title.split('[');
    } else if (info && sharePage) {
      title = event.title;
      user = info.sharedTo;
    }
  }

  // JSX
  /* Render user info */
  const renderUserInfo = () => {
    return (
      <>
        {user && dataReady ? (
          <div className={styles.account} data-testid="user">
            <MDIIcon className={styles['icon-account']} icon={Account} fill="var(--color-white)" />
            <span className={styles.email}>{user}</span>
          </div>
        ) : (
          <div style={{ width: '30%' }}>
            <div className={styles.account} style={{ float: 'right' }}>
              <div>
                <Skeleton
                  circle={true}
                  width={22}
                  height={22}
                  baseColor="#3f3f3f"
                  highlightColor="#3e3e3e"
                />
              </div>
              <div className={styles.email}>
                <Skeleton
                  width={170}
                  height={20}
                  style={{ marginLeft: 15 }}
                  baseColor="#3f3f3f"
                  highlightColor="#3e3e3e"
                />
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <div className={styles.header}>
      <div className={styles['header-content']}>
        <div className={styles.entry}>
          {dataReady ? (
            /* We use class name to determine which icon to display. Can't use CSS module  */
            <SVG className="solink-logo" type="solink-logo" />
          ) : (
            <Skeleton
              className={styles['skeleton-circle']}
              width={30}
              height={30}
              circle={true}
              baseColor="#3f3f3f"
              highlightColor="#3e3e3e"
            />
          )}
          <div className={styles['title-wrapper']}>
            <div className={styles.title} data-testid="title">
              {dataReady ? (
                title
              ) : (
                <Skeleton
                  className={styles['skeleton-title']}
                  baseColor="#3f3f3f"
                  highlightColor="#3e3e3e"
                />
              )}
            </div>
          </div>
        </div>
        {sharePage && renderUserInfo()}
      </div>
    </div>
  );
};

export default Header;
